import styled, { css } from 'styled-components';

import { rem, toRemString } from '../../utils';

export type ToolbarVariant = 'static' | 'float';

const COLLAPSE_BUTTON_WIDTH = 16;
const COLLAPSE_BUTTON_HEIGHT = 88;

export const StyledWrapper = styled.div<{
  direction?: string;
  visible?: boolean;
  variant: ToolbarVariant;
}>`
  display: flex;
  width: 100%;
  height: 100%;
  max-width: ${({ theme, visible }) =>
    rem(visible ? theme.Components.ToolBar.wrapperSize : theme.Components.ToolBar.drawerGap)};
  min-width: ${({ theme, visible }) =>
    rem(visible ? theme.Components.ToolBar.wrapperSize : theme.Components.ToolBar.drawerGap)};
  z-index: 0;
  /* z-index: ${({ theme }) => theme.ZIndex.ZIndex.Elevated}; */
  position: relative;

  ${({ variant, theme }) => css`
    flex-direction: row;
    gap: ${variant === 'float' && rem(theme.Spacing.Size.XSmall)};
    align-items: ${variant === 'float' ? 'center' : 'inherit'};
    transition: all ${theme.Transition.Timing.Out};
    ${variant === 'float' ? theme.Scrollbar.Panel : theme.Scrollbar.Default}
  `}
`;

export const StyledWrapperComponentTab = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;

  &.menu-component-tab .tabs-wrapper,
  &.menu-component-tab .tabs-content-wrapper {
    height: 100%;
    position: relative;
  }
`;

export const StyledContentDrawer = styled.div<{
  visible: boolean;
  variant: ToolbarVariant;
}>`
  ${({ theme, variant }) => css`
    max-width: ${rem(theme.Components.ToolBar.contentContainer)};
    height: 100%;
    position: relative;
    background-color: ${theme.Components.Panel.Background};
    border-radius: ${variant === 'float' ? rem(theme.Border.Radius.Large) : 0};
    box-shadow: ${toRemString([0, 6, 8, 0])} rgba(0, 0, 0, 0.08),
      ${toRemString([0, 3, 4, -4])} rgba(0, 0, 0, 0.12),
      ${toRemString([0, 9, 8, 8])} rgba(0, 0, 0, 0.05);
    overflow: hidden;
    pointer-events: all;
    padding-bottom: ${rem(theme.Spacing.Size.XSmall)};
  `}
`;

export const StyledContentWrapper = styled.div<{
  visible: boolean;
  variant: ToolbarVariant;
}>`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  ${({ theme, visible }) => css`
    margin-left: ${rem(theme.Components.ToolBar.navigationGap)};
    transition: transform ${theme.Transition.Timing.Out};
    transform: ${visible ? 'translateX(0%)' : 'translateX(-100%)'};
    padding-left: ${rem(theme.Components.ToolBar.drawerGap)};
  `}
`;

export const StyledContentContainer = styled.div<{ active: boolean }>`
  flex-direction: column;
  flex: 1;
  position: relative;
  width: 100%;
  height: 100%;

  ${({ theme, active }) => css`
    display: ${active ? 'flex' : 'none'};
    gap: ${`${rem(theme.Spacing.Size.XSmall)}`};
  `}
`;

export const StyledCollapseButtonContainer = styled.div<{
  variant: ToolbarVariant;
  visible: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  filter: drop-shadow(2.5px 0.3px 2px rgba(0, 0, 0, 0.03));
  transition: opacity 0ms;
  pointer-events: all;

  ${({ visible, variant }) => css`
    visibility: ${!visible && variant === 'float' ? 'hidden' : 'visible'};
    opacity: ${visible ? 1 : 0};
    width: ${rem(COLLAPSE_BUTTON_WIDTH)};
    height: ${rem(COLLAPSE_BUTTON_HEIGHT)};
    right: 0;
  `}
`;

export const StyledCollapseButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: baseline;

  i,
  svg {
    width: ${rem(COLLAPSE_BUTTON_WIDTH)};
    height: ${rem(COLLAPSE_BUTTON_HEIGHT)};
  }
`;

export const StyledCollapseInnerIcon = styled.span`
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
`;
